export const PERSONAL_ID_VERIFICATION_POLLING_CONFIG = {
  minPollingTimeMs: 1000, // 1 second
  maxPollingTimeMs: 5000, // 5 seconds
  pollingIntervalMs: 1000, // 1 second
};
